import React, {forwardRef, useEffect, useLayoutEffect, useState} from 'react';
import DragAndDrop, {DragDataManager} from "../../partials/DragAndDrop";
import _ from 'lodash'
import {Target, UnplacedSources} from "../../interactions/DnD";
import UnplacedItemHolder from "./UnplacedItemHolder";
import DropTarget from "./DropTarget";
import DragSource from "./DragSource";
import Popup from "../../partials/OLIPopup";

const FinalDragDrop = props => {
    const {
        config = {},
        disabled = false,
        style = {}
    } = props;
    
    const {
        customDragLayer = false,
        onLimitReachedHover = ()=> console.warn('Limit reached over'),
       
    } = config

    const dropZones = [0]
    const dragItems = props.data.dragDropPartial.draggables
    const initialState = {}
    const randomizeOptions = false
    
    const dataManager = new DragDataManager({ targetData: dropZones, sourceData: dragItems, initialState, randomizeOptions })
    const { dragData, manager } = dataManager 

    const [questionState, setQuestionState] = React.useState({
        selectorState: dataManager.createState(),
    })

    const [showOutro, setShowOutro] = useState(false);
    const [showReport, setShowReport] = useState(0);
    const [highlighter, setHighlighter] = useState(null);
    const [lastHighlighter, setLastHighlighter] = useState(null);
    const [showIntro, setShowIntro] = useState(true);

    const [draggingCompleted, setDraggingCompleted ] = useState(false)


    const [feedback, setFeedback] = useState(null);
    const [rejectedFeedback, setRejectedFeedback] = useState(null);
    
    const [currentDroppedOrder, setCurrentDroppedOrder] = useState([])
    

    React.useEffect(() => {
        const droppedItems = questionState.selectorState.targetStates[0]?.dS
        if (!Array.isArray(droppedItems))  return
        setCurrentDroppedOrder(droppedItems.map( d =>  d.i))
    }, [questionState.selectorState, dragItems])
    
   useEffect(() => {
       console.log(currentDroppedOrder)
       
   }, [currentDroppedOrder])

    const validateItem = (item, order) => {
        console.log(item, order)
        let meetsReqs = true
        const preReq = item?.reject
        if (!preReq) return meetsReqs; // item does not need validation.
        if (typeof preReq === 'object') {
            if (Array.isArray(preReq?.needsBefore)) {
                preReq.needsBefore.forEach( neededBefore => {
                    const neededIndex = order.findIndex( c => c.i === neededBefore)
                    const itemIndex = order.findIndex(c => c.i === item.i)
                    console.log({order, neededIndex, itemIndex})
                    if ((neededIndex === -1 || neededIndex > itemIndex)  && meetsReqs === true ) {
                        meetsReqs =  false;
                        setRejectedFeedback(preReq?.rejectedFeedback || 'Invalid rejected drop feedback')
                    }
                })
            }
        }
        return meetsReqs
    }
    
    const handleDrop = (target, item) => {
        
        if (target === undefined) {
            // back to unplaced.
            const droppedItems = questionState.selectorState.targetStates[0]?.dS
            if (!droppedItems) return
            const removed = droppedItems.filter( t => {
                console.log(t, item.data)
                return t.k !== item.data.k
            })
            if (_.isEqual(droppedItems, removed)) return
            setQuestionState( (questionState) => {
                const copy = _.cloneDeep(questionState)
                copy.selectorState.targetStates[0].dS = removed
                copy.selectorState.unplacedSourcesState.push(item.data)
                return copy
            })
            return
        }
        // check reject criteria here for item.i
   

       
        
        if (target?.dS.find(d => d.k === item.data.k) ) return
        const updateFunc =  manager.move(item.data, target)
        if (!updateFunc) {
            console.warn("updateFunc not valid while dropping", updateFunc)
            return
        }

        const movedOrder = updateFunc(questionState.selectorState)
        const validates = validateItem(item.data, movedOrder.targetStates[0].dS.map( st => ({...st, ...dragItems.find( (di, i) => i === item.data.i) })))
        if (!validates) return
        
        // it validtes procees to persist state with updated order
        
        typeof updateFunc === 'function' && setQuestionState((questionState) => ({ ...questionState, selectorState: movedOrder }))
    }
    
    const handleMove =  (dragItem, hoverItem) => {
        console.log(dragItem, hoverItem)
       
        const newOrder = [...currentDroppedOrder]
        console.log({currentDroppedOrder, newOrder, dragItem, hoverItem})
        swapElements(newOrder, newOrder.findIndex( d => d === dragItem.i), newOrder.findIndex( d => d === hoverItem.i))
        let meetsReqs = validateItem(newOrder)
        if (meetsReqs === false) return
        const updateFunc =  manager.order(dragItem, hoverItem)
        
        if (!updateFunc) {
            console.warn("updateFunc not valid while moving", updateFunc)
            return
        }

        const movedOrder = updateFunc(questionState.selectorState)
        let validates = validateItem(dragItem, movedOrder.targetStates[0].dS.map( st => ({...st, ...dragItems.find( (di, i) => i === dragItem.i) })))
        if (!validates) return

        validates = validateItem(hoverItem, movedOrder.targetStates[0].dS.map( st => ({...st, ...dragItems.find( (di, i) => i === hoverItem.i) })))
        if (!validates) return
        
        
        typeof updateFunc === 'function' && setQuestionState((questionState) => ({ ...questionState, selectorState: updateFunc(questionState.selectorState) }))
    }
    const handleLimitReachedDrop = () => { console.log("LIMIT REACHED") }
    const calculateFeedback = () => {
        props.audioController.removeAudio(props.data.instructionAudio)
        let newFeedback = null;
        let complete = false;
        const incorrectRoundIndex = props.data.dragDropPartial.correctOrder.findIndex((e,i) => {
            if (e !== currentDroppedOrder[i] && currentDroppedOrder[i] !== undefined) {
                return true
            }
        })

        if (incorrectRoundIndex === -1) {
            console.log("currentDroppedOrder.length" , currentDroppedOrder.length);
            if (currentDroppedOrder.length < 4) {
                newFeedback = props.data.dragDropPartial.incorrectFeedbacks[currentDroppedOrder.length][`empty`];
                props.audioController.playAudioByName(`empty-${currentDroppedOrder.length+1}`)
            } else {
                newFeedback = props.data.dragDropPartial.correctFeedback;
                complete = true
                props.audioController.playAudioByName(`correct`)
            }
        } else {
            console.log("incorrectRoundIndex" , incorrectRoundIndex);
            console.log("props.data.incorrectFeedbacks[incorrectRoundIndex]" , props.data.dragDropPartial.incorrectFeedbacks[incorrectRoundIndex]);
            newFeedback = props.data.dragDropPartial.incorrectFeedbacks[incorrectRoundIndex][`draggable-${currentDroppedOrder[incorrectRoundIndex]}`];
            if (currentDroppedOrder.length === 4) {
                props.audioController.playAudioByName(`empty-4`)
            } else {
                props.audioController.playAudioByName(`draggable-${currentDroppedOrder[incorrectRoundIndex]}`)
            }
        }

        setFeedback(newFeedback);
        return complete
        // const currentRound = droppedOrder.length-1;
        // const feedbackRoundIndex = incorrectFeedbacks.findIndex((e) => {
        //   return e.hasOwnProperty(`draggable-${i}`)
        // })
        // const feedback = incorrectFeedbacks[feedbackRoundIndex][`draggable-${id}`]
        // setIncorrectFeedback(feedback);
    }


    // const calculateFeedback = () => {
    //     props.audioController.removeAudio(props.data.dragDropPartial.instructionAudio)
    //     let newFeedback = null;
    //     let complete = false;
    //     //console.log("correctOrder"+props.data.dragDropPartial);
    //     //console.log("droppedOrder"+droppedOrder);
    //     const incorrectRoundIndex = currentDroppedOrder.findIndex((e,i) => {
    //         //console.log(props.data.dragDropPartial[i]+":::::"+e);
    //
    //         if (e !== props.data.dragDropPartial.correctOrder[i] && props.data.dragDropPartial.correctOrder[i] !== undefined) {
    //             //console.log("passed");
    //             return true
    //         }else if (e !== props.data.dragDropPartial.correctOrder[i] && props.data.dragDropPartial.correctOrder[i] == undefined) {
    //             //console.log("failed");
    //             return false
    //         }
    //     })
    //     //console.log("incorrectRoundIndex::"+incorrectRoundIndex);
    //     if (incorrectRoundIndex === -1) {console.log('incorrect fffff',currentDroppedOrder.length)
    //         if (currentDroppedOrder.length < 5) {
    //             newFeedback = props.data.dragDropPartial.incorrectFeedbacks[currentDroppedOrder.length][`empty`];
    //             //props.audioController.playAudioByName(`empty-${currentDroppedOrder.length+1}`)
    //             props.audioController.playAudioByName(`empty-${currentDroppedOrder.length}-${currentDroppedOrder.length+1}`)
    //             //console.log('aud1', `empty-${currentDroppedOrder.length+1}`);
    //         } else if (currentDroppedOrder.length == 6 ) {
    //             newFeedback = props.data.dragDropPartial.failedFeedback;
    //             complete = false
    //             props.audioController.playAudioByName(`draggable-4`)
    //         } else {
    //             newFeedback = props.data.dragDropPartial.correctFeedback;
    //             complete = true
    //             //console.log('aud2');
    //             props.audioController.playAudioByName(`route3crossing4correct1`)
    //         }
    //     } else {
    //         newFeedback = props.data.dragDropPartial.incorrectFeedbacks[incorrectRoundIndex][`draggable-${currentDroppedOrder[incorrectRoundIndex]}`];
    //         if (currentDroppedOrder.length === 4) {
    //             //console.log('aud3', `draggable-${currentDroppedOrder[incorrectRoundIndex]}`);
    //             props.audioController.playAudioByName(`empty-4`)
    //         } else {
    //             //console.log('aud4', `draggable-${currentDroppedOrder[incorrectRoundIndex]}`);
    //             props.audioController.playAudioByName(`draggable-${currentDroppedOrder[incorrectRoundIndex]}`)
    //         }
    //     }
    //
    //     setFeedback(newFeedback);
    //     return complete
    //  
    // }
    const showReports =(i)=>{
        console.log(i);
        setShowReport(i);
    }
    
    useEffect( () => {
        if (showOutro) {
            setShowOutro(true)
            props.audioController.removeAllAudio();
            props.audioController.playAudioByName('trip3c4_concl')
            showReports(0);

            setTimeout(()=>
                    setHighlighter('highlight1')
                , 7000);

            setTimeout(()=>
                    setHighlighter('highlight2')
                , 9000);

            setTimeout(()=>
                    showReports(1)
                , 13000);
            setTimeout(()=>
                    showReports(2)
                , 21000);
            setTimeout(()=>
                    showReports(3)
                , 29000);
            setTimeout(()=>
                    showReports(4)
                , 39000);

            setTimeout(()=>
                    setLastHighlighter('highlight1')
                , 45000);

            setTimeout(()=>
                    setLastHighlighter('highlight2')
                , 50000);

            setTimeout(()=>
                    setLastHighlighter('final')
                , 53500);

        }
    }, [showOutro])
    const submit = () => {
        props.audioController.removeAllAudio();
        setDraggingCompleted(calculateFeedback());
    }
    const retry = (resetDraggables = true) => {
        setRejectedFeedback(null);
        setFeedback(null)
        props.audioController.removeAllAudio();
        if (resetDraggables)
        setQuestionState({
            selectorState: dataManager.createState(),
        })
    }
    useEffect(() => {
        console.log(rejectedFeedback)
        
    }, [rejectedFeedback])
    
    useEffect(()=> {
        props.audioController.playAudioByName(props.data.dragDropPartial.introAudio);
        return () => {
            // audio cleanup
            props.audioController.removeAllAudio();
        }
    }, [])
    const handleIntroComplete = () => {
        props.audioController.removeAudio(props.data.dragDropPartial.introAudio);
        props.audioController.playAudioByName(props.data.dragDropPartial.instructionAudio);
        setShowIntro(false)
    }

    return (
        <>
            
            <DragAndDrop 
                 dndProps={[
                    _.get(questionState, 'selectorState').unplacedSourcesState, 
                    _.get(questionState, 'selectorState').targetStates, 
                    dragData, 
                    manager,
                 ]}
                 disabled={disabled}
                 config={{ allowSort:true, customDragLayer,  source: DragSource, target: DropTarget, unplacedHolder: UnplacedItemHolder, actions:{handleDrop, handleMove, handleLimitReachedDrop}, onLimitReachedHover}}
                 style={style}>
    
                    <div className={`FinalDragDrop`}>
                        {showIntro &&
                            <Popup data={props.data.dragDropPartial.introPopup} onComplete={handleIntroComplete} />
                        }
                        { feedback &&
                            <Popup class={'drag-drop-feedback'} data={feedback} onComplete={() => {
                                    if (draggingCompleted ) {
                                        setShowOutro(true)
                                   
                                    } else {
                                        retry()
                                    }
                                
                                }
                            } />
                        }
                        { rejectedFeedback !== null && (
                                <Popup class={'rejected-feedback'} data={rejectedFeedback} onComplete={draggingCompleted  ? props.onComplete : () => retry(false)}  />
                            )
                        }
                        
                    <div className={'DragAndDrop'} >

                        <div className={'header'}>
                            <h2>{props.data.dragDropPartial.headerText}</h2>
                            <div className={'yellow-line'}></div>
                        </div>
                        <UnplacedSources className={'bounds'} />
                        <div className={'Droppable droppable-first'} style={{top: "0px", left: "639px", height: "630px", width: "361px" }}>
                            <div className={`instructions`}><p>{props.data.dragDropPartial.instructions}</p></div>
                            {dropZones && dropZones.map((d, i) => <div className='TargetHolder' key={`target_${i}`}><Target index={i} >
                            
                            </Target>
                                <div className={'slotsContainer'}>
                                {dragItems.map( (e,i) => {
                                    return <div className={'slot'}>
                                        <div className={'slot-text'} dangerouslySetInnerHTML={{__html: i+1}}></div>
                                        <div className={'slot-background'}></div>


                                    </div>
                                })
                                }
                                </div>
                            </div>) }
                        </div>
                        <div className={`global-button reset-button ${currentDroppedOrder.length>0 ? 'enable' : 'disable'}`} onClick={retry}>{props.data.dragDropPartial.resetText.toUpperCase()}</div>
                        <div className={`global-button submit-button ${currentDroppedOrder.length > 0 ? 'enable' : 'disable'}`} onClick={submit}>{props.data.dragDropPartial.submitText.toUpperCase()}</div>
                        
                    </div>
                </div>
             
            </DragAndDrop>
            {showOutro && <div className={`outro-container`}>
                <div className={`report0 ${highlighter} ${showReport===0?'show':''}`}>
                    <div className="leftmsg">
                        <p>This is typical Emergency Notification Sign or ENS.</p>
                    </div>
                    <div className={`btn`}>
                        <div className="global-button continue-button" onClick={props.onComplete}>CONTINUE</div>
                    </div>
                </div>
                <div className={`report1 ${showReport===1?'show':''}`}>
                    <div className="msg">
                        <ul>
                            <li>Located througout the country at railroad crossings</li>
                            <li>Usually attached to the crossbuck post or signal mast</li>
                        </ul>
                    </div>
                    <div className={`btn`}>
                        <div className="global-button continue-button" onClick={props.onComplete}>CONTINUE</div>
                    </div>
                </div>
                <div className={`report2 ${showReport===2?'show':''}`}>
                    <div className="msg">
                        <ul>
                            <li>Located througout the country at railroad crossings</li>
                            <li>Usually attached to the crossbuck post or signal mast</li>
                            <li>Tells the railroad exactly where you are stuck on the tracks</li>
                            <li>Notify nearby trains</li>
                        </ul>
                    </div>
                    <div className={`btn`}>
                        <div className="global-button continue-button" onClick={props.onComplete}>CONTINUE</div>
                    </div>
                </div>
                <div className={`report3 ${showReport===3?'show':''}`}>
                    <div className="msg">
                        <p>If you...{<br/>}Can't see the railroad emergency number{<br/>}Can't find the sign</p>
                        <p>Then...{<br/>}Call 911 for the local police{<br/>}Ask them to contact the railroad</p>
                    </div>
                    <div className={`btn`}>
                        <div className="global-button continue-button" onClick={props.onComplete}>CONTINUE</div>
                    </div>
                </div>
                <div className={`report4 ${lastHighlighter} ${showReport===4?'show':''}`}>
                    <div className="msg">
                        <p>
                            Get clear of the tracks!
                        </p>
                        <p>Run away from the tracks in the direction the train is approaching</p>
                        <p className={`${lastHighlighter==='final'?'enable':'disable'}`}>Click continue for your Driver's Report for this trip.</p>

                    </div>
                    <div className={`btn`}>
                        <div className="global-button continue-button" onClick={props.onComplete}>CONTINUE</div>
                    </div>
                </div>
                {/*<Popup data={props.data.outro} onComplete={props.onComplete} /> */}
            </div>

            }
        </>
    )
}
function swapElements(arr, i1, i2) {
    let temp = arr[i1];
    arr[i1] = arr[i2];
    arr[i2] = temp;
}
export default FinalDragDrop